<script setup lang="ts">
/** 通用弹层:标题 + 内容 + 底部按钮;点遮罩不关闭(考试里误触成本高) */
defineProps<{ open: boolean; title: string; width?: number }>();
</script>

<template>
  <Teleport to="body">
    <div v-if="open" class="modal-bg" role="dialog" aria-modal="true">
      <div class="modal" :style="{ width: `${width ?? 520}px` }">
        <div class="mh">{{ title }}</div>
        <div class="mb"><slot /></div>
        <div class="mf"><slot name="footer" /></div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.modal-bg {
  position: fixed;
  inset: 0;
  background: rgba(10, 24, 48, 0.45);
  display: grid;
  place-items: center;
  z-index: 150;
}
.modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: var(--shadow-lg);
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
}
.mh {
  padding: 18px 22px 12px;
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid var(--line);
}
.mb {
  padding: 16px 22px;
  overflow: auto;
  font-size: 13.5px;
  line-height: 1.7;
}
.mf {
  padding: 12px 22px 18px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid var(--line);
}
/* ── 学生端 H5:弹层贴着屏幕两边留 12,宽度不再按电脑上给的像素;内容区自己滚,底部按钮平分一行 ── */
.h5 .modal {
  width: calc(100vw - 24px) !important;
  max-width: var(--m-col);
  max-height: calc(100dvh - 32px);
}
.h5 .mh {
  padding: 14px 16px 10px;
}
.h5 .mb {
  padding: 12px 16px;
  font-size: var(--m-fs);
}
.h5 .mf {
  padding: 10px 16px 14px;
  flex-wrap: wrap;
}
.h5 .mf :deep(.btn) {
  flex: 1 1 auto;
}
</style>
